<template>
    <el-dialog
        :visible="visible"
        title="Nhập kết quả đào tạo hội nhập (HR - Tuyển chính thức)"
        width="620px"
        custom-class="rcv-dialog rcv-training-eval-dialog"
        :close-on-click-modal="false"
        append-to-body
        @update:visible="handleClose"
    >
        <div v-if="candidate" class="rcv-training-eval">
            <!-- Cảnh báo nếu không thuộc phòng nhân sự -->
            <el-alert
                v-if="!isHrDepartment"
                title="Quyền hạn bị giới hạn"
                type="error"
                description="Chỉ nhân sự thuộc phòng Nhân sự (HR) mới có quyền nhập kết quả đào tạo hội nhập."
                show-icon
                :closable="false"
                class="mb-3"
            />

            <!-- Thẻ tóm tắt thông tin ứng viên -->
            <div class="rcv-training-eval__cand-card">
                <div class="rcv-training-eval__cand-head">
                    <div class="rcv-training-eval__avatar">
                        <i class="el-icon-reading"></i>
                    </div>
                    <div class="rcv-training-eval__cand-info">
                        <div class="rcv-training-eval__name-row">
                            <span class="rcv-training-eval__name">
                                {{ candidate.name || ("Ứng viên #" + candidate.id) }}
                            </span>
                            <span class="rcv-training-eval__id">#{{ candidate.id }}</span>
                            <el-tag size="mini" type="primary" effect="plain">
                                Tuyển chính thức
                            </el-tag>
                            <el-tag size="mini" type="warning" effect="dark" class="ml-1">
                                <i class="el-icon-reading"></i> Đã gửi ĐT hội nhập (#16)
                            </el-tag>
                        </div>
                        <div class="rcv-training-eval__meta">
                            <span v-if="candidateJobTitle"><i class="el-icon-suitcase"></i> {{ candidateJobTitle }}</span>
                            <span v-if="candidate.phone"><i class="el-icon-phone-outline"></i> {{ candidate.phone }}</span>
                            <span v-if="candidate.email"><i class="el-icon-message"></i> {{ candidate.email }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Form Nhập kết quả đào tạo hội nhập -->
            <el-form
                ref="formRef"
                :model="form"
                :rules="rules"
                :disabled="!isHrDepartment"
                label-position="top"
                size="small"
                class="rcv-training-eval-form"
                @submit.native.prevent="handleSubmit"
            >
                <!-- Thẻ lựa chọn Kết quả: Đạt (Pass) / Không đạt (Fail) -->
                <el-form-item label="Kết quả đào tạo hội nhập" required>
                    <div class="rcv-choice-cards">
                        <!-- Lựa chọn 1: Đạt (Pass) -->
                        <div
                            class="rcv-choice-card rcv-choice-card--pass"
                            :class="{ 'is-active': form.result === 'pass' }"
                            @click="setResult('pass')"
                        >
                            <div class="rcv-choice-card__icon">
                                <i class="el-icon-circle-check"></i>
                            </div>
                            <div class="rcv-choice-card__body">
                                <div class="rcv-choice-card__title">ĐẠT (PASS)</div>
                                <div class="rcv-choice-card__desc">
                                    Hoàn thành đào tạo hội nhập -> Chuyển sang <b>Cần đánh giá thử việc (#22)</b>
                                </div>
                            </div>
                            <div class="rcv-choice-card__radio">
                                <i :class="form.result === 'pass' ? 'el-icon-success' : 'el-icon-circle-check'"></i>
                            </div>
                        </div>

                        <!-- Lựa chọn 2: Không đạt (Fail) -->
                        <div
                            class="rcv-choice-card rcv-choice-card--fail"
                            :class="{ 'is-active': form.result === 'fail' }"
                            @click="setResult('fail')"
                        >
                            <div class="rcv-choice-card__icon">
                                <i class="el-icon-circle-close"></i>
                            </div>
                            <div class="rcv-choice-card__body">
                                <div class="rcv-choice-card__title">KHÔNG ĐẠT (FAIL)</div>
                                <div class="rcv-choice-card__desc">
                                    Không đạt đào tạo hội nhập -> Chuyển sang <b>Đã ĐG thử việc - Fail (#24)</b>
                                </div>
                            </div>
                            <div class="rcv-choice-card__radio">
                                <i :class="form.result === 'fail' ? 'el-icon-error' : 'el-icon-circle-close'"></i>
                            </div>
                        </div>
                    </div>
                </el-form-item>

                <!-- Thông báo tiến trình tiếp theo khi PASS -->
                <transition name="el-fade-in-linear">
                    <div v-if="form.result === 'pass'" class="rcv-next-step-box mb-3">
                        <div class="rcv-next-step-box__icon">
                            <i class="el-icon-s-claim text-success"></i>
                        </div>
                        <div class="rcv-next-step-box__content">
                            <div class="rcv-next-step-box__title">
                                Tiến trình tiếp theo: <b>Cần đánh giá thử việc (#22)</b>
                            </div>
                            <div class="rcv-next-step-box__desc">
                                Ứng viên vượt qua đào tạo hội nhập. Hồ sơ sẽ được tự động chuyển sang bước <b>Cần đánh giá thử việc</b> để Teamlead theo dõi và đánh giá hiệu quả trong quá trình thử việc.
                            </div>
                        </div>
                    </div>
                </transition>

                <!-- Trường hợp: KHÔNG ĐẠT -> Bắt buộc nhập lý do -->
                <transition name="el-fade-in-linear">
                    <div v-if="form.result === 'fail'" class="rcv-fail-section mb-3">
                        <el-form-item label="Lý do không đạt đào tạo hội nhập" prop="reason" required>
                            <el-input
                                v-model="form.reason"
                                type="textarea"
                                :rows="3"
                                placeholder="Nhập chi tiết lý do ứng viên không đạt đào tạo hội nhập (VD: Không tham gia đủ buổi, không đạt bài test...)..."
                                maxlength="500"
                                show-word-limit
                            />
                        </el-form-item>

                        <!-- Gợi ý lý do nhanh -->
                        <div class="rcv-quick-reasons mb-2">
                            <span class="text-muted" style="font-size: 12px; margin-right: 6px;">Gợi ý nhanh:</span>
                            <el-tag
                                v-for="tag in commonFailReasons"
                                :key="tag"
                                size="small"
                                class="rcv-quick-tag"
                                @click="addReason(tag)"
                            >
                                + {{ tag }}
                            </el-tag>
                        </div>
                    </div>
                </transition>

                <!-- Điểm đánh giá đào tạo (Tuỳ chọn) -->
                <div class="rcv-form-row">
                    <el-form-item label="Điểm kiểm tra đào tạo (nếu có)" class="rcv-form-col">
                        <el-input
                            v-model="form.score"
                            placeholder="VD: 8.5/10 hoặc 85/100"
                            clearable
                        />
                    </el-form-item>
                </div>

                <!-- Nhận xét chi tiết của HR về buổi đào tạo -->
                <el-form-item label="Nhận xét chi tiết về quá trình đào tạo hội nhập (Tuỳ chọn)">
                    <el-input
                        v-model="form.note"
                        type="textarea"
                        :rows="3"
                        placeholder="Nhập nhận xét về tinh thần học hỏi, thái độ, sự tiếp thu văn hóa công ty của ứng viên..."
                        maxlength="1000"
                        show-word-limit
                    />
                </el-form-item>
            </el-form>
        </div>

        <span slot="footer" class="dialog-footer">
            <el-button size="small" :disabled="submitting" @click="handleClose">Đóng</el-button>
            <el-button
                size="small"
                :type="form.result === 'fail' ? 'danger' : 'success'"
                :loading="submitting"
                :disabled="!isHrDepartment"
                :icon="form.result === 'fail' ? 'el-icon-close' : 'el-icon-check'"
                @click="handleSubmit"
            >
                {{ form.result === 'fail' ? 'Xác nhận Không đạt (#24)' : 'Xác nhận Đạt & Chuyển Cần đánh giá thử việc (#22)' }}
            </el-button>
        </span>
    </el-dialog>
</template>

<script>
import {
    CAN_DANH_GIA_THU_VIEC,
    DA_NHAP_KET_QUA_DANH_GIA_THU_VIEC_FAIL,
} from "@/core/config/recruitmentCvs/recruitmentCvsOption";

export default {
    name: "TrainingEvaluationDialog",
    props: {
        visible: { type: Boolean, default: false },
        candidate: { type: Object, default: null },
        orders: { type: Array, default: () => [] },
        isHrDepartment: { type: Boolean, default: true },
        submitting: { type: Boolean, default: false },
    },
    data() {
        return {
            form: {
                result: "pass",
                reason: "",
                score: "",
                note: "",
            },
            commonFailReasons: [
                "Không tham gia đầy đủ các buổi đào tạo",
                "Không đạt bài kiểm tra đánh giá cuối khóa",
                "Ý thức và tác phong không phù hợp văn hóa công ty",
                "Ứng viên chủ động xin dừng đào tạo",
                "Không hoàn thành bài tập thực hành",
            ],
            rules: {
                reason: [
                    {
                        validator: (rule, value, callback) => {
                            if (this.form.result === "fail" && (!value || !value.trim())) {
                                callback(new Error("Vui lòng nhập lý do không đạt đào tạo hội nhập"));
                                return;
                            }
                            callback();
                        },
                        trigger: ["blur", "change"],
                    },
                ],
            },
        };
    },
    computed: {
        candidateJobTitle() {
            if (!this.candidate) return "";
            const c = this.candidate;
            const found = this.orders.find((o) =>
                String(o.id) === String(c.job_id) ||
                String(o.id) === String(c.order_id) ||
                String(o.id) === String(c.raw_job_id) ||
                (o.recruitment_job_id && String(o.recruitment_job_id) === String(c.job_id)) ||
                (o.recruitment_job_id && String(o.recruitment_job_id) === String(c.raw_job_id))
            );
            return found ? (found.title || found.position_title || "") : (c.order_title || "");
        },
    },
    watch: {
        visible(val) {
            if (val) {
                this.initForm();
            }
        },
        candidate() {
            if (this.visible) {
                this.initForm();
            }
        },
    },
    methods: {
        initForm() {
            const c = this.candidate || {};
            this.form = {
                result: "pass",
                reason: c.probation_reason || "",
                score: "",
                note: "",
            };
            this.$nextTick(() => {
                if (this.$refs.formRef) {
                    this.$refs.formRef.clearValidate();
                }
            });
        },
        setResult(val) {
            this.form.result = val;
            this.$nextTick(() => {
                if (this.$refs.formRef) {
                    this.$refs.formRef.clearValidate();
                }
            });
        },
        addReason(tag) {
            if (!this.form.reason) {
                this.form.reason = tag;
            } else if (!this.form.reason.includes(tag)) {
                this.form.reason = `${this.form.reason}; ${tag}`;
            }
            if (this.$refs.formRef) {
                this.$refs.formRef.validateField("reason");
            }
        },
        handleClose() {
            this.$emit("update:visible", false);
        },
        handleSubmit() {
            if (!this.candidate) return;
            if (!this.isHrDepartment) {
                this.$message.warning("Chỉ HR mới có quyền nhập kết quả đào tạo hội nhập");
                return;
            }

            this.$refs.formRef.validate((valid) => {
                if (!valid) return;

                const isPass = this.form.result === "pass";
                // Nếu đánh pass: status = "Cần đánh giá thử việc" (#22)
                // Nếu fail: status = "Đã nhập kết quả đánh giá thử việc - Fail" (#24)
                const targetStatus = isPass
                    ? CAN_DANH_GIA_THU_VIEC
                    : DA_NHAP_KET_QUA_DANH_GIA_THU_VIEC_FAIL;

                const reason = (this.form.reason || "").trim();
                const note = (this.form.note || "").trim();
                const score = (this.form.score || "").trim();

                let noteContent = isPass
                    ? `[Đào tạo hội nhập - ĐẠT (Pass) -> Chuyển Cần đánh giá thử việc (#22)]`
                    : `[Đào tạo hội nhập - KHÔNG ĐẠT (Fail) (#24)]`;

                if (score) {
                    noteContent += `\nĐiểm kiểm tra: ${score}`;
                }
                if (!isPass && reason) {
                    noteContent += `\nLý do không đạt: ${reason}`;
                }
                if (note) {
                    noteContent += `\nNhận xét: ${note}`;
                }

                const payload = {
                    id: this.candidate.id,
                    status: targetStatus,
                    training_result: this.form.result,
                    probation_reason: !isPass ? reason : null,
                    reason: !isPass ? reason : undefined,
                    note: noteContent,
                    message: noteContent,
                    candidate: {
                        ...this.candidate,
                        status: targetStatus,
                        training_result: this.form.result,
                        probation_reason: !isPass ? reason : null,
                    },
                };

                this.$emit("submit", payload);
            });
        },
    },
};
</script>

<style scoped>
.rcv-training-eval {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

/* Thẻ tóm tắt thông tin ứng viên */
.rcv-training-eval__cand-card {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    padding: 14px 16px;
}
.rcv-training-eval__cand-head {
    display: flex;
    align-items: center;
    gap: 12px;
}
.rcv-training-eval__avatar {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: #fef3c7;
    color: #d97706;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    flex-shrink: 0;
}
.rcv-training-eval__cand-info {
    flex: 1;
    min-width: 0;
}
.rcv-training-eval__name-row {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    margin-bottom: 4px;
}
.rcv-training-eval__name {
    font-size: 15px;
    font-weight: 700;
    color: #0f172a;
}
.rcv-training-eval__id {
    font-size: 12px;
    font-weight: 600;
    color: #64748b;
}
.rcv-training-eval__meta {
    display: flex;
    gap: 14px;
    font-size: 12px;
    color: #64748b;
    flex-wrap: wrap;
}

/* Thẻ lựa chọn Pass / Fail */
.rcv-choice-cards {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
}
.rcv-choice-card {
    border: 2px solid #e2e8f0;
    border-radius: 10px;
    padding: 14px;
    cursor: pointer;
    display: flex;
    align-items: flex-start;
    gap: 10px;
    transition: all 0.2s ease;
    background: #ffffff;
}
.rcv-choice-card:hover {
    border-color: #cbd5e1;
    transform: translateY(-1px);
}
.rcv-choice-card__icon {
    font-size: 24px;
    margin-top: 2px;
}
.rcv-choice-card--pass .rcv-choice-card__icon {
    color: #10b981;
}
.rcv-choice-card--fail .rcv-choice-card__icon {
    color: #ef4444;
}
.rcv-choice-card__body {
    flex: 1;
}
.rcv-choice-card__title {
    font-size: 14px;
    font-weight: 700;
    margin-bottom: 4px;
}
.rcv-choice-card--pass .rcv-choice-card__title {
    color: #065f46;
}
.rcv-choice-card--fail .rcv-choice-card__title {
    color: #991b1b;
}
.rcv-choice-card__desc {
    font-size: 12px;
    color: #64748b;
    line-height: 1.4;
}
.rcv-choice-card__radio {
    font-size: 20px;
    color: #cbd5e1;
}

/* Trạng thái active */
.rcv-choice-card--pass.is-active {
    border-color: #10b981;
    background: #ecfdf5;
}
.rcv-choice-card--pass.is-active .rcv-choice-card__radio {
    color: #10b981;
}
.rcv-choice-card--fail.is-active {
    border-color: #ef4444;
    background: #fef2f2;
}
.rcv-choice-card--fail.is-active .rcv-choice-card__radio {
    color: #ef4444;
}

/* Hộp bước tiếp theo khi pass */
.rcv-next-step-box {
    background: #f0fdf4;
    border: 1px solid #bbf7d0;
    border-radius: 8px;
    padding: 12px 14px;
    display: flex;
    gap: 10px;
    align-items: flex-start;
}
.rcv-next-step-box__icon {
    font-size: 20px;
    margin-top: 2px;
}
.rcv-next-step-box__content {
    flex: 1;
}
.rcv-next-step-box__title {
    font-size: 13px;
    font-weight: 600;
    color: #166534;
    margin-bottom: 2px;
}
.rcv-next-step-box__desc {
    font-size: 12px;
    color: #15803d;
    line-height: 1.4;
}

/* Gợi ý lý do nhanh */
.rcv-quick-reasons {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    align-items: center;
}
.rcv-quick-tag {
    cursor: pointer;
    user-select: none;
    font-size: 12px;
    transition: all 0.15s ease;
}
.rcv-quick-tag:hover {
    background-color: #e2e8f0;
    color: #1e293b;
    border-color: #94a3b8;
}

.rcv-form-row {
    display: flex;
    gap: 14px;
}
.rcv-form-col {
    flex: 1;
}
</style>
